import { Map } from 'immutable'
import { ImageSize, ImageSizesProps } from "../../modernBlocks/modernBlocks.state"
import { DP } from "../blockDefinitions"
import { DPImageStyle } from "./imageSizes"

export const parseDrupalImageUrls = (
  fieldMediaImage: DP.FieldMediaImage,
  fieldMediaSource?: DP.FieldMediaSource,
  imageName?: Map<DPImageStyle, string>,
  fallbackImageName?: DPImageStyle
): ImageSizesProps | undefined => {
  const originalImageUrl = fieldMediaImage?.target.uri[0].url
  const fallbackWidth = fieldMediaImage?.width // VALUE FROM DRUPAL FROM UPLOADED FILE (ORIGINAL)
  const fallbackHeight = fieldMediaImage?.height // VALUE FROM DRUPAL FROM UPLOADED FILE (ORIGINAL)
  const styleUrls = transformStyleUrlsToArray(fieldMediaImage?.target.style_urls, fallbackWidth, fallbackHeight)
  const altText = fieldMediaImage?.alt
  const source = fieldMediaSource ? fieldMediaSource[0].value : undefined
  if (originalImageUrl == undefined || styleUrls == undefined) return undefined
  return {
    image: {
      altText: altText || '',
      source: source || '',
      originalImageUrl: originalImageUrl,
      imageFallback: fallbackImageName != undefined ? filterStyleUrl(styleUrls, fallbackImageName) : originalImageUrl,
      imageSizes: imageName != undefined ? filterStyleUrls(styleUrls, imageName) : styleUrls
    }
  }
}

// Tests if the url is internal, otherwise test if it does not point to the cms
const isValidFrontendImageUrl = (url: string): boolean =>
  new URL(url).host.includes('.amazonaws.com')

// Convert style_urls object to array
// Test if the crop name `k` starts with a number (e.g. '400x400' or '400w'). If so, strip the `x` or `w`/`h` to determine the width/height, otherwise return undefined
const transformStyleUrlsToArray = (styleUrls: DP.StyleUrls, fallbackWidth: number, fallbackHeight: number): ImageSize[] =>
  Object.entries(styleUrls).map(([k, v]) => {
    let width = k.match(/^\d/) != null ? (k.endsWith('w_webp') ? k.slice(0, -6) : k.endsWith('w') ? k.slice(0, -1) : k.split('x')[0]) : fallbackWidth.toString()
    let height = k.match(/^\d/) != null ? (k.endsWith('h_webp') ? k.slice(0, -6) : k.endsWith('h') ? k.slice(0, -1) : k.split('x')[1]) : fallbackHeight.toString()
    if (width == undefined) width = Math.floor(height ? parseInt(height) / (16/9) : 600).toString()
    if (height == undefined) height = Math.floor(width ? parseInt(width) * (16/9) : 400).toString()
    const validFrontendUrl = isValidFrontendImageUrl(v)
    return {
      style: k as DPImageStyle,
      width: width,
      height: height,
      url: v,
      validFrontendUrl: validFrontendUrl
    }
  }) as ImageSize[]

// Loop through all available DP crops and filter only the crops necessary
const filterStyleUrls = (styleUrls: ImageSize[], imageName: Map<DPImageStyle, string>) => {
  if (imageName == undefined) {
    console.log('--> Pass imageName in parseDrupalImageUrls to show image in block')
  }

  let res: ImageSize[] = []
  const imageNameArray = imageName.toArray().map(([imageStyle, width]) => ({ style: imageStyle, width: width }))

  for (let index = 0; index < imageNameArray.length; index++) {
    const current = imageNameArray[index]
    const styleUrlIndex = styleUrls.findIndex((image) => image.style == current.style)
    if (styleUrlIndex > -1) {
      res.push({
        style: styleUrls[styleUrlIndex].style,
        width: styleUrls[styleUrlIndex].width,
        height: styleUrls[styleUrlIndex].height,
        url: styleUrls[styleUrlIndex].url,
        validFrontendUrl: styleUrls[styleUrlIndex].validFrontendUrl,
      })
    }
  }

  return res
}

// Loop through all available DP crops and filter only the crops necessary
const filterStyleUrl = (styleUrls: ImageSize[], imageName: DPImageStyle) => {
  const styleUrlIndex = styleUrls.findIndex((image) => image.style == imageName)
  const res = styleUrls[styleUrlIndex]?.url
  
  return (res) ? res: ''
}
